export const Privileges = {
  SALES: 'sales',
  TICKET_TYPE_CHANGE: 'ticket_type_change',
  GIFT_TICKET_USAGE: 'gift_ticket_usage',
  PAYMENT_METHOD_CHANGE: 'payment_method_change',
  USER_GET: 'user_get',
  USER_CHANGE: 'user_change',
  CUSTOMER_MANAGE: 'customer_manage',
  LEGAL_PERSON_GET: 'legal_person_get',
  ROLES_MANAGE: 'roles_manage',
  PRIVILEGES_MANAGE: 'privileges_manage',
  DISCOUNT_APPLY: 'discount_apply',
  DAILY_REPORT: 'daily_report',
  REFUND_SALES_TERMINAL: 'refund_sales_terminal',
  REFUND_WEB: 'refund_web',
  REFUND_PROMOTER: 'refund_promoter',
  REFUND_ALL: 'refund_all',
  REFUND_EXPIRED: 'refund_expired',
  BOOKING_CREATE: 'booking_create',
  BOOKING_CHANGE: 'booking_change',
  BOOKING_RELEASE: 'booking_release',
  BOOKING_RELEASE_WITHOUT_PAYMENT: 'booking_release_without_payment',
  BOOKING_VIEW: 'booking_view',
  TICKET_WITHOUT_PRICE_PRINT: 'ticket_without_price_print',
  BOOKING_MARK_PAYMENT_RECEIVED: 'booking_mark_payment_received',
  ADVANCED_REFUND_PROCESS: 'advanced_refund_process',
  REFUND_EXCHANGE: 'refund_exchange',
  USER_GET_ARCHIVED: 'user_get_archived',
  USER_ADMIN: 'user_admin',
  BOOKING_PAYMENT_CANCEL: 'booking_payment_cancel',
  LOGE_VIEW: 'loge_view',
  SALESPOINT_MANAGE: 'salespoint_manage',
  TICKET_CUSTOM_PRICE: 'ticket_custom_price',
  TICKETS_PRINT_COUNT_BY: 'tickets_print_count_by',
  BOOKING_CREATE_PROMOTER: 'booking_create_promoter',
  PROMOTER_SALES: 'promoter_sales',
  EVENT_MANAGERS_MANAGE: 'event_managers_manage',
  API_USERS_MANAGE: 'api_users_manage',
  VIEW_INTERNET_TRANSACTIONS: 'view_internet_transactions',
  REGISTRATION_REPORT: 'registration_report',
  TICKET_REGISTRATION: 'ticket_registration',
  DELETE_REGISTRATION_DATA: 'delete_registration_data',
  TRANSACTION_REPRINT: 'transaction_reprint',
  PAYMENT_OPTIONS: 'payment_options',
  EVENT_VIEW_PREPARATION: 'event_view_preparation',
  ADDTOCART_BEFORE_SALES_STARTDATE: 'addtocart_before_sales_startdate',
  VENUEMAP_REFUND: 'venuemap_refund',
  TICKETS_SHOW_EXACT_NUMBER: 'tickets_show_exact_number',
  REPORTING_PROMOTER_DASHBOARD: 'reporting_promoter_dashboard',
  REPORTING_PROMOTER_MY_EVENTS: 'reporting_promoter_my_events',
  REPORTING_PROMOTER_DETAILED: 'reporting_promoter_detailed',
  REPORTING_VENUE_OWNER: 'reporting_venue_owner',
  REPORTING_VENUE_OWNER_SHOW_REVENUE: 'reporting_venue_owner_show_revenue',
  REPORTING_SALESPOINT_SALES: 'reporting_salespoint_sales',
  INVOICE_GENERATE: 'invoice_generate',
  INVOICE_CHANGE: 'invoice_change',
  TRANSLATIONS_ADMIN: 'translations_admin',
  TRANSLATIONS_ADMIN_DOWNLOAD: 'translations_admin_download',
  PUBLIC_VENUES_ADMIN: 'public_venues_admin',
  LEGAL_PERSON_INVOICING_VIEW: 'legal_person_invoicing_view',
  LEGAL_PERSON_PROJECT_MANAGER: 'legal_person_project_manager',
  LEGAL_PERSON_ADMIN: 'legal_person_admin',
  LEGAL_PERSON_CHANGE: 'legal_person_change',
  LEGAL_PERSON_REPRESENTATIVES_MANAGE: 'legal_person_representatives_manage',
  BOOKING_PAYMENT_LINK: 'booking_payment_link',
  CATEGORY_MANAGE: 'category_manage',
  SELF_SERVICE_EVENTS_VIEW: 'self_service_events_view',
  SELF_SERVICE_EVENTS_MANAGE: 'self_service_events_manage',
  EVENTS_FULL_ACCESS: 'events_full_access',
  SELF_SERVICE_TRANSACTIONS_PAYMENT_REVERSAL: 'self_service_transactions_payment_reversal',
  ADMIN_DASHBOARD: 'admin_dashboard',
  LEGAL_PERSON_BANK_ACCOUNT_VIEW: 'legal_person_bank_account_view',
  LEGAL_PERSON_BANK_ACCOUNT_ADD_VIA_PAYMENT_LINK: 'legal_person_bank_account_add_via_payment_link',
  AUDIT_GET: 'audit_get',
  FEE_MANAGE: 'fee_manage',
  VIEW_EVENT_OWNER_TRANSACTIONS: 'view_event_owner_transactions',
  REPORTING_OVER_EVENTS: 'reporting_over_events',
  REPORTING_EVENT_SALES_SUMMARY: 'reporting_event_sales_summary',
  TICKET_TOOL_VIEW: 'ticket_tool_view'
}
